(function ($) {
  const STICKY_CTA_SELECTOR = '.js-product-full .is-sticky';
  const STICKY_CLASS = 'is-sticky';

  Drupal.behaviors.stickyAddToBagV1 = {
    attach: function (context) {
      $('.js-sticky-add-to-bag', context)
        .once('initStickyAddToBagV1')
        .each(function () {
          let stickyIndicatorObserver;
          let footerObserver;
          let stickyFooterHeight = 0;
          let isMobile = false;

          function checkStickyActive() {
            return $(STICKY_CTA_SELECTOR).length > 0;
          }

          function showStickyATB() {
            const $ctas = [
              $('.js-product-full__add-to-bag'),
              $('.js-product-full__inventory-status'),
              $('.js-product-full-notify-me')
            ];

            $ctas.forEach(function ($cta) {
              if ($cta.hasClass('hidden')) {
                return;
              }
              $cta.addClass(STICKY_CLASS).css('bottom', `${stickyFooterHeight}px`);
            });
          }

          function hideStickyATB() {
            $(STICKY_CTA_SELECTOR).removeClass(STICKY_CLASS).css('bottom', '0px');
          }

          function observeATBBlockVisible() {
            const headerHeight = $('.site-header__wrapper').height();
            const threshold = -headerHeight;
            const callback = (entries) => {
              entries.forEach((entry) => {
                const isStickyActive = checkStickyActive();
                const {
                  boundingClientRect: { bottom },
                  intersectionRatio
                } = entry;

                if (intersectionRatio === 1 && bottom > threshold && isStickyActive) {
                  hideStickyATB();
                } else if (intersectionRatio === 0 && bottom < threshold && !isStickyActive) {
                  showStickyATB();
                }
              });
            };

            stickyIndicatorObserver = new IntersectionObserver(callback, {
              rootMargin: `${headerHeight}px 0px 0px 0px`,
              scrollMargin: '0px'
            });
            stickyIndicatorObserver.observe(document.querySelector('.js-sticky-add-to-bag'));
          }

          function observeStickyFooter() {
            const target = document.querySelector('footer .drawer-container');

            if (!target) {
              return;
            }
            const $footer = $(target);
            let lastValue = '';

            footerObserver = new MutationObserver((mutations) => {
              mutations.forEach((m) => {
                if (m.attributeName === 'class') {
                  if (lastValue === $footer.attr('class')) {
                    return;
                  }
                  lastValue = $footer.attr('class');
                  stickyFooterHeight = $footer.hasClass(STICKY_CLASS) ? $footer.height() : 0;
                  $(STICKY_CTA_SELECTOR).css('bottom', `${stickyFooterHeight}px`);
                }
              });
            });
            footerObserver.observe(target, {
              attributes: true,
              attributeFilter: ['class']
            });
          }

          function configureSticky() {
            observeATBBlockVisible();
            observeStickyFooter();
          }

          function destroySticky() {
            if (checkStickyActive()) {
              hideStickyATB();
            }

            stickyIndicatorObserver?.disconnect();
            footerObserver?.disconnect();
          }

          if (!window.Unison) {
            return;
          }

          Unison.on('change', function (bp) {
            const bpMediumWidth = parseInt(Unison.fetch.all()['usn-medium'], 10);
            const currentWidth = parseInt(bp.width, 10);

            if (currentWidth < bpMediumWidth && !isMobile) {
              isMobile = true;
              configureSticky();
            } else if (currentWidth >= bpMediumWidth && isMobile) {
              isMobile = false;
              destroySticky();
            }
          });
        });
    }
  };
})(jQuery);
